import { render, staticRenderFns } from "./FirstLevelMenu.vue?vue&type=template&id=109db57c&scoped=true&"
import script from "./FirstLevelMenu.vue?vue&type=script&lang=js&"
export * from "./FirstLevelMenu.vue?vue&type=script&lang=js&"
import style0 from "./FirstLevelMenu.vue?vue&type=style&index=0&id=109db57c&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109db57c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TabletMenuItem: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/layout/TabletMenuItem.vue').default,DesktopMenuItem: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/layout/DesktopMenuItem.vue').default})
